// extracted by mini-css-extract-plugin
export var infoItem = "_ov-2";
export var title = "_ov-0";
export var value = "_ov-1";